import React from 'react';
import MarkdownRenderer from '@/app/components/chat-renderer/markdown-renderer';
import { ProcessedMessage } from '../hooks/useMessageProcessor';
import { detectWidgetType, setIframeViewMode } from '../utils/iframe';

export interface IframePanelProps {
  message: ProcessedMessage | null;
  isExpanded: boolean;
  isVisible: boolean;
  className?: string;
}

/**
 * Displays iframe content in split-screen mode
 * PRESERVES EXISTING LAYOUT LOGIC
 */
export function IframePanel({
  message,
  isExpanded,
  isVisible,
  className = '',
}: IframePanelProps) {
  if (!isVisible || !message?.iframeContent) {
    return (
      <div className={`h-full transition-all duration-300 overflow-hidden w-0 ${className}`} />
    );
  }
  
  const widgetType = detectWidgetType(message.iframeContent);
  const shouldCenter = widgetType.isChart || widgetType.isCard;
  const viewMode = isExpanded ? 'full' : 'half';
  const iframeWithViewMode = setIframeViewMode(message.iframeContent, viewMode);
  
  return (
    <div className={`h-full transition-all duration-300 overflow-hidden ${className}`}>
      <div
        className={`w-full h-full bg-gray-50 ${
          shouldCenter && !widgetType.isGrid 
            ? 'flex items-center justify-center p-8' 
            : ''
        }`}
      >
        <div className={
          shouldCenter && !widgetType.isGrid 
            ? 'w-full max-w-6xl' 
            : 'w-full h-full'
        }>
          <MarkdownRenderer 
            content={iframeWithViewMode}
            isFullHeight={!shouldCenter || widgetType.isGrid}
          />
        </div>
      </div>
    </div>
  );
}

